import { render } from "./MaxWidth.vue?vue&type=template&id=4a65587e&scoped=true&ts=true"
import script from "./MaxWidth.vue?vue&type=script&lang=ts"
export * from "./MaxWidth.vue?vue&type=script&lang=ts"

import "./MaxWidth.vue?vue&type=style&index=0&id=4a65587e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a65587e"]])

export default __exports__